import AddArticleComponent from "./quill-editor";

export default function AdminNewArticlePage() {
    return (
        <AddArticleComponent />
      )
}